import React from 'react';
import { Helmet } from 'react-helmet';

function Privacy_Policy_Seo() {
    return (
        <div>
            <Helmet>
                <title>Privacy Policy | FinestPay</title>
                <meta name="description" content="We take privacy seriously. Please read our privacy policy. Your data is in safe hands. We are safe, secure and reliable money transfer company. Trusted by hundreds of satisfied customers." />
                <meta property="og:title" content="Privacy Policy | FinestPay" />
                <meta property="og:description" content="We take privacy seriously. Please read our privacy policy. Your data is in safe hands. We are safe, secure and reliable money transfer company. Trusted by hundreds of satisfied customers." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/privacy-policy"/>
            </Helmet>
        </div>
    )
}

export default Privacy_Policy_Seo
